(function (angular) {
    angular.module('shared').directive('nfNotRequired', function () {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attr, ctrl) {
                scope.$watch(attr.nfNotRequired, function (newValue) {
                    var valid = true;
                    if (moment(newValue, "YYYY-MM-DD").isValid() && moment(ctrl.$modelValue, "YYYY-MM-DD").isValid())
                        valid = false;

                    if(scope.addeventForm.DueDate) {
                        scope.addeventForm.DueDate.$setValidity("nfNotRequired", valid);
                        scope.addeventForm.DueDate.$setDirty();
                    }
                        
                    if(scope.addeventForm.PaidByMeOn) {
                        scope.addeventForm.PaidByMeOn.$setValidity("nfNotRequired", valid);
                    }
                });
            }
        };
    });
}(angular));